import { render, staticRenderFns } from "./To.vue?vue&type=template&id=508dc69e&"
import script from "./To.vue?vue&type=script&lang=js&"
export * from "./To.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports